(function () {
  'use strict';
  try {
    var cfg = window.FA_BROWSE_CONFIG;
    if (!cfg || !cfg.storeId || !cfg.apiBase) return;
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (cp && typeof cp.marketingAllowed === 'function' && cp.marketingAllowed() === false) return;

    var K_VID = 'fa_browse_vid', K_CART = 'fa_browse_cart';
    function get(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
    function set(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
    function rand() {
      var a = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789', out = '', i, buf;
      try { buf = new Uint8Array(20); window.crypto.getRandomValues(buf); } catch (e) { buf = null; }
      for (i = 0; i < 20; i++) out += a.charAt(buf ? buf[i] % a.length : Math.floor(Math.random() * a.length));
      return out;
    }
    function cartCookie() {
      var m = document.cookie.match(/(?:^|;\s*)cart=([^;]+)/);
      return m ? m[1] : null;
    }

    var vid = get(K_VID);
    if (!vid || !/^[A-Za-z0-9_-]{8,64}$/.test(vid)) { vid = rand(); set(K_VID, vid); }

    var tok = null;
    try {
      var u = new URL(window.location.href);
      tok = u.searchParams.get('_fav');
      if (tok) {
        u.searchParams.delete('_fav');
        window.history.replaceState(window.history.state, '', u.pathname + u.search + u.hash);
      }
    } catch (e) {}

    var url = String(cfg.apiBase).replace(/\/$/, '') + '/api/storefront/browse/view';
    function send(productId) {
      var body = JSON.stringify({ s: cfg.storeId, v: vid, c: cartCookie(), i: tok, p: productId || null });
      tok = null;
      try {
        if (navigator.sendBeacon && navigator.sendBeacon(url, new Blob([body], { type: 'text/plain' }))) return;
      } catch (e) {}
      try { fetch(url, { method: 'POST', body: body, keepalive: true, mode: 'cors', headers: { 'Content-Type': 'text/plain' } }); } catch (e) {}
    }

    var cart = cartCookie();
    var cartIsNew = !!cart && cart !== get(K_CART);
    if (cfg.productId || tok || cartIsNew) {
      if (cart) set(K_CART, cart);
      send(cfg.productId);
    }
    // A cart made on this page (add to cart in a drawer, then straight to
    // checkout) is only in the cookie after load: report it on the way out.
    window.addEventListener('pagehide', function () {
      try {
        var c = cartCookie();
        if (c && c !== get(K_CART)) { set(K_CART, c); send(null); }
      } catch (e) {}
    });
  } catch (e) {}
})();
